export const DATA_TEST_IDS_INJECTORS = {
  h1: 'h1-injector',
  h2: 'h2-injector',
  h3: 'h3-injector',
  p: 'p-injector',
  guidLabel: 'guid-label-injector',
  dt: 'dt-injector',
  code: 'code-injector',
  kbd: 'kbd-injector',
  tabs: 'tabs-bar-injector',
  link: 'link-injector',
  hints: 'hints-injector',
  dd: 'dd-injector',
  section: 'section-injector',
  highlight: 'highlight-injector',
  ol: 'ol-injector',
  ul: 'ul-injector',
  li: 'li-injector',
  table: 'table-injector',
  img: 'img-injector',
  accordion: 'accordion-injector',
  dl: 'dl-injector',
  caption: 'caption-injector',
  dlHttp: 'dl-http-injector',
  command: 'command-injector',
} as const;
